module.exports = __webpack_public_path__ + "static/img/down-3.0decc5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contactpic/down-3.jpg
// module id = f3HV
// module chunks = 52